// Тип для параметров колонки с действиями
export interface ActionColumnParams {
  icon: string;
  onClick: (data: any) => void;
  type: "edit" | "delete";
}

// Компонент ячейки с иконкой действия
export const ActionCellRenderer = (props: any) => {
  const { icon, onClick, type } = props.colDef.context || {};

  const handleClick = () => {
    if (onClick) {
      onClick(props.data);
    }
  };

  return (
    <div className="action-column">
      {icon && (
        <button
          onClick={handleClick}
          className={`action-button ${type}`}
          aria-label="Действие"
        >
          {icon}
        </button>
      )}
    </div>
  );
};
// Определение колонки с действиями
export const createActionColumn = (params: ActionColumnParams) => {
  return {
    headerName: "",
    width: 50,
    suppressMovable: true,
    resizable: false,
    sortable: false,
    filter: false,
    cellRenderer: ActionCellRenderer,
    context: params,
  };
};
